import React from 'react'
import PropTypes from 'prop-types'
import PerformanceItem from '../PerformanceItem'

function YoyModal() {
	return (
		<div className='performance_item_modal yoy_modal'>
			<h3>YOY</h3>
			<p>
				The old idiom is especially true in social advertising—you need to spend money to make money (or gain brand awareness).
			</p>
			<p>
				With the market poised to double social investments within the next 5 years, brands need to keep up with the industry to compete.
			</p>
			<p>
				In order to stay competitive in the Facebook advertising market, it&apos;s recommended that you keep your budget growing at a rate equal or greater than the industry.
			</p>
		</div>
	)
}

const renderYoyBody = (value, benchmark) => {
	let percentStr = parseFloat(value).toLocaleString('en', {style: 'percent'})
	const benchmarkStr = benchmark.us.toLocaleString('en', {style: 'percent'})
	return (
		<p>Your annual spend grew by {percentStr} which is {value >= benchmark.us ? 'above' : 'below'} the industry average of {benchmarkStr}.</p>
	)
}

function YoyPerformanceItem(props) {
	const { score, maxScore, value, benchmark } = props.apiScore
	// "yoyGrowth":{"score":13,"maxScore":13,"value":10,"benchmark":0.12}
	return (
		<PerformanceItem
			title="Spend Growth"
			score={score}
			maxScore={maxScore}
			showPerformanceModal={() => { props.showPerformanceModal('yoy') }}>
			{renderYoyBody(value, benchmark)}
		</PerformanceItem>
	)
}
YoyPerformanceItem.propTypes = {
	apiScore: PropTypes.object,
	showPerformanceModal: PropTypes.func
}

export { YoyModal, YoyPerformanceItem }


// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/performance_items/Yoy.js